<template>
	<div>
		<v-form ref="form" class="mx-2" lazy-validation @submit.prevent="submit">
			<v-card class="mx-auto pa-3" max-width="400" color="#eee">
				<div class="text-left">
					<v-btn class="" small @click="dialogSmsPatternManager = true">
						مدیریت قالب های پیامک
					</v-btn>
					<!-- <v-btn class="mr-2" small :loading="loading" @click="saveSmsSettings()">
						ذخیره تنظیمات
					</v-btn> -->

				</div>
				<v-card-text>
					<v-row>
						<v-col cols="12">
							<v-combobox v-model="appSettings.walletChargeSmsPattern" clearable required :rules="[(val) => !!val || 'قالب پیامک را انتخاب کنید']" :items="smsPatterns" label="قالب را انتخاب کنید" single-line return-object :error-messages="errorMessages" item-text="title" item-value="id" />
							<sms-pattern :data="appSettings.walletChargeSmsPattern" :onlySample="true" />
						</v-col>
					</v-row>
				</v-card-text>

				<v-card-actions class="d-flex align-center justify-center">
				</v-card-actions>
			</v-card>
			<div class="pt-3 text-center">
				<v-btn @click="sendSms" color="secondary" class="w-100" :loading="loading">
					<v-icon class="ml-2">mdi-message-text-outline</v-icon>
					ارسال پیامک
				</v-btn>
			</div>
		</v-form>

		<v-dialog v-model="dialogSmsPatternManager" scrollable persistent max-width="450px">
			<v-card>
				<v-card-title>
					<div><span class="headline">مدیریت قالب های پیامک</span></div>
					<v-spacer />
					<v-btn @click="dialogSmsPatternManager = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<v-container>
						<sms-pattern-manager ref="smsPatternManager" v-if="dialogSmsPatternManager" @itemsUpdated="updatePatterns" group="walletCharge" />
					</v-container>
				</v-card-text>
			</v-card>
		</v-dialog>

	</div>
</template>

<script>
	import api from '@/util/app-api'
	import toast from '@/util/toast'
	import { call, get } from 'vuex-pathify'

	export default {
		name: 'WalletChargeSms',
		props: {
			memberId: { type: Number },
		},
		components: {
			'sms-pattern-manager': () => import('@/components/SmsPatternManager.vue'),
			'sms-pattern': () => import('@/components/SmsPattern.vue'),
		},
		data() {
			return {
				dialogSmsPatternManager: false,
				errorMessages: '',
				appSettings: { dashboardSettings: {} },
				smsPatterns: [],
				loading: false,
				tempPattern: null,
			}
		},
		computed: {
			...get('memberAppSettings', [
				'iceOnlinePaymentGateway'
			]),
			smsCredit() {
				return this.settings?.smsCredit || 0
			},
		},
		mounted() {
			this.loadAppSettings()
			this.loadSmsPatterns()
		},
		methods: {
			...call('appSettings/*'),
			saveSmsSettings() {
				this.loading = true
				var data = _.cloneDeep(this.appSettings)
				this.sync(data).then(x => {
					this.loading = false
					toast.success('اطلاعات با موفقیت ذخیره شد.')
				}).catch(err => {
					this.loading = false
					toast.error(err.message)
				})
			},
			loadAppSettings() {
				this.fetch({ force: true }).then(x => {
					this.appSettings = x
					this.tempPattern = this.appSettings.walletChargeSmsPattern ? { ...this.appSettings.walletChargeSmsPattern } : null
				})
			},
			loadSmsPatterns() {
				api.get('admin/smsPattern/list', null)
					.then(
						response => {
							this.smsPatterns = response.filter(x => x.status === 1 && x.category === 5)
						})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(x => {
					})
			},
			updatePatterns(items) {
				this.smsPatterns = items.filter(x => x.status === 1 && x.category === 5)
			},
			async sendSms() {
				if (!this.$refs.form.validate()) { return }

				if (this.tempPattern?.id !== this.appSettings.walletChargeSmsPattern?.id)
					await this.saveSmsSettings()

				this.loading = true
				api.post('admin/AppSms/SendWalletCharge?id=' + this.memberId, null)
					.then(response => {
						this.loading = false
						toast.success('پیامک ارسال شد.')
					})
					.catch(err => {
						this.loading = false
						toast.error(err.message)
					})
			}
		},
	}
</script>
<style></style>
